import { render, staticRenderFns } from "./editPlan.vue?vue&type=template&id=3ada8bd4&scoped=true&"
import script from "./editPlan.vue?vue&type=script&lang=ts&"
export * from "./editPlan.vue?vue&type=script&lang=ts&"
import style0 from "./editPlan.vue?vue&type=style&index=0&id=3ada8bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ada8bd4",
  null
  
)

export default component.exports